// src/components/ProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { hasPermission } from "../utils/permissions";

const ProtectedRoute = ({ children, requiredPermission = null }) => {
  // Hooks must be called unconditionally at the top
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [allowed, setAllowed] = useState(true);

  // Check auth once on mount
  useEffect(() => {
    const token = localStorage.getItem("session_token");
    const userData = localStorage.getItem("user_data");
    setIsAuthenticated(!!(token && userData));
    setAuthChecked(true);
  }, []);

  // Check permission when requiredPermission changes
  useEffect(() => {
    let mounted = true;
    const check = async () => {
      if (!requiredPermission) {
        if (mounted) setAllowed(true);
        return;
      }
      const ok = await hasPermission(requiredPermission.category, requiredPermission.permission);
      // Check fallback permission if specified
      let finalOk = ok;
      if (!ok && requiredPermission.fallbackPermission) {
        const fallbackOk = await hasPermission(requiredPermission.category, requiredPermission.fallbackPermission);
        finalOk = fallbackOk;
      }
      if (mounted) setAllowed(finalOk);
    };
    check();
    return () => {
      mounted = false;
    };
  }, [requiredPermission]);

  // Defer rendering until auth check is done
  if (!authChecked) return null;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (requiredPermission && !allowed) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div style={{ 
          padding: '40px', 
          background: '#fff', 
          borderRadius: '10px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          maxWidth: '500px',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#e74c3c', marginBottom: '20px' }}>
            ❌ Access Denied
          </h2>
          <p style={{ fontSize: '16px', color: '#666' }}>
            You do not have permission to access this page.
          </p>
          <p style={{ fontSize: '14px', color: '#999', marginTop: '10px' }}>
            Required permission: {requiredPermission.category}.{requiredPermission.permission}
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;